import { Controller } from "@hotwired/stimulus"

/**
 * Connects to data-controller="contacts--timeline-filters-draft"
 *
 * Enables the timeline filters drawer's "Clear filters" button only while the
 * drawer holds at least one value — parity with the React drawers'
 * `disabled={!hasActiveDraftFilters}` (CONEK-8232). It reads the DRAFT (what is
 * in the form right now, applied or not), so the button lights up as soon as a
 * field gets a value and goes back to disabled when every field is emptied.
 *
 * The form's fields come from several conek-ui components that do not all
 * announce a change the same way: text inputs and native selects fire
 * `input`/`change`, the date picker dispatches `ui--date-picker:change`, and the
 * multi-select adds/removes hidden `name[]` inputs without any event. The first
 * three reach `refresh` through the form's data-action; a MutationObserver on
 * the form covers the last.
 */
export default class extends Controller {
  static targets = ["form", "clear"]

  connect() {
    this.refresh = this.refresh.bind(this)
    this.observer = new MutationObserver(this.refresh)
    // Only childList: typing / ticking change DOM properties, not attributes,
    // and those already arrive as input/change events.
    this.observer.observe(this.formTarget, { subtree: true, childList: true })
    this.refresh()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  refresh() {
    if (!this.hasClearTarget) return

    this.clearTarget.disabled = !this.hasDraftValue()
  }

  hasDraftValue() {
    for (const [, value] of new FormData(this.formTarget)) {
      if (typeof value === "string" && value.trim() !== "") return true
    }
    return false
  }
}
